<template>
	<div class="">
		<vm-header></vm-header>
		<saixuantop3></saixuantop3>
		<div class="container">
			<div class="xunhuan">
				<div class="xh" v-for="(item,i) in list">
					<div class="kuang">
						<a href="" class="a1">{{item.tit}}</a>
					</div>
					<div class="kuang">
						<span>{{item.shuzi}}</span>
					</div>
					<div class="kuang">
						<span>{{item.kemu}}</span>
					</div>
					<div class="kuang">
						<span>{{item.bili}}</span>
					</div>
					<div class="kuang">
						<!-- <a href="" class="a2">{{item.sc}}</a>-->
						<span class="a2">{{item.sc}}</span>
					</div>
					<div class="kuang">
						<a href="" class="a3"><span>{{item.bili1}}</span></a>
					</div>
					<div class="kuang">
						<span>{{item.bili3}}</span>
					</div>
					<div class="kuang">
						<span>{{item.bili4}}</span>
					</div>
					<div class="kuang">
						<span>{{item.bili5}}</span>
					</div>
					<div class="kuang">
						<span>{{item.bili6}}</span>
					</div>
				</div>
			</div>
			<!-- <div class="model">
				<div class="modelb">
					<div class="model2">
						<div class="model2-top">
							<img src="../../../static/img/p7.png">
							<span>智能选科</span>
						</div>
						<div class="model2-bottom">
							<span>搜索并选择自己想填报的专业，然后根据选择的专业生成最佳选科方案</span>
						</div>
					</div>
				</div>
				<div class="modelc">
					<div class="model3">
						<div class="model3-top">
							<img src="../../../static/img/p8.png">
							<span>根据测评选科</span>
						</div>
						<div class="model3-bottom">
							<span>搜索并选择自己想填报的专业，然后根据选择的专业生成最佳选科方案</span>
						</div>
					</div>
				</div>
			</div> -->
		</div>
		<item7></item7>
	</div>
</template>

<script>
	import vmHeader from '../../components/vmHeader.vue'
	import saixuantop3 from '../../components/saixuantop3.vue'
	import item7 from '../../components/item7.vue'
	export default {
		name: "",
		components: {
			vmHeader,
			item7,
			saixuantop3
		},
		data() {
			return {
				list: [{
						tit: "院校名称",
						shuzi: "院校类别",
						kemu: "院校类型",
						bili: "所在地区",
						sc: "院校隶属",
						bili1: "院校性质",
						bili3: "专业名称",
						bili4: "包含专业",
						bili5: "专业层次",
						bili6: "选科要求"
					}, {
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					}, {
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					}, {
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					}, {
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					}, {
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					}, {
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					}, {
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					}, {
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					}, {
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					},

					{
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					},

					{
						tit: "北京航空大学",
						shuzi: "双一流、211、北京市重点大学、研究生院",
						kemu: "财经类",
						bili: "上海市",
						sc: "教育局",
						bili1: "公办",
						bili3: "计算机与技术",
						bili4: "本科",
						bili5: "本科",
						bili6: "历史，政治，地理"
					}
				]
			}
		},
		methods: {

		}


	}
</script>

<style scoped>
	.container {
		width: 1458px;
		margin-top: 30px;
	}

	.model {
		display: flex;
		justify-content: center;
	}

	.a3 {
		color: #666666;
		padding: 5px;
		text-decoration: none;
	}

	.model3-bottom {
		margin: 10px;
		text-align: center;
	}

	.zhong {
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.model3-bottom span {
		display: block;
		font-size: 14px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
	}

	.model3-top span {
		text-align: center;
		line-height: 70px;
		font-size: 24px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
	}

	.model3-top {
		justify-content: center;
		display: flex;
		color: white;

	}

	.model3 {
		padding: 10px;
		width: 390px;
		height: 172px;
		background: url(../../../static/img/p5.png);
		background-size: 100% 100%;
	}


	.model2-bottom {
		margin: 10px;
		text-align: center;
	}

	.zhong {
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.model2-bottom span {
		display: block;
		font-size: 14px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
	}

	.model2-top span {
		text-align: center;
		line-height: 70px;
		font-size: 24px;
		font-weight: 500;
		color: #FFFFFF;
		opacity: 1;
	}

	.model2-top {
		justify-content: center;
		display: flex;
		color: white;

	}

	.model2 {
		padding: 10px;
		width: 390px;
		height: 172px;
		background: url(../../../static/img/p4.png);
		background-size: 100% 100%;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(1) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(2) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(3) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(4) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(5) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(6) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(7) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(8) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(9) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(10) {
		border: none;
	}

	.xunhuan .xh:nth-of-type(1) a:nth-of-type(1) {
		color: white;
		border: none;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF;
	}
	.xunhuan .xh:nth-of-type(1) span{
		color: white;
		border: none;
		font-size: 18px!important;
		font-family: PingFang SC;
		font-weight: 500;
		color: #FFFFFF!important;
		width: auto;
		
	}

	.xunhuan .xh:nth-of-type(1){
		border: none !important;
		color: white !important;
		background: rgb(246, 100, 100);
		opacity: 1;
		
	}
	.xunhuan .xh:nth-of-type(1) .kuang{
		padding: 0 28px!important;
	}
	.xunhuan .xh:nth-of-type(1) .kuang:nth-of-type(2){
		width: 230px!important;
	}
	.xunhuan .xh .kuang span{
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #333333;
		
	}
	.xunhuan .xh .kuang:nth-of-type(2){
		width: 250px;
	}

	.xunhuan {
		display: block;
	}

	.xh {

		height: 50px;
		display: flex;
		margin-bottom: 10px;
		
	}

	.kuang {
		border: 1px solid #EBE9E9;
		/* width: 20%; */
	}

	.xunhuan .a2 {
		text-decoration: none;
		font-size: 18px;
		font-weight: 500;
		line-height: 20px;
		/* color: #FE9603; */
		opacity: 1;
	}

	.xunhuan .a1 {
		text-decoration: none;
		color: #29A7E1;
		font-size: 18px;
		font-weight: 500;
		line-height: 20px;
		color: #29A7E1;
		opacity: 1;
	}

	.kuang {
		align-items: center;
		justify-content: center;
		display: flex;
		padding: 0 32px;
	}

	.xunhuan {
		color: #666666;
		text-align: center;
		justify-content: space-evenly;
	}

	@media (max-width:750px) {
		.one {
			width: 138%;
		}

		.xh {
			width: 1390px;
		}
		.xunhuan .xh:nth-of-type(1) .a2:nth-of-type(1) {
			font-size: 12px;
		}

		.xunhuan {
			display: block;
			overflow: auto;
		}

		.xh {
			display: flex;
		}

		.xunhuan .a1 {
			font-size: 13px;
		}

		.model {
			display: block
		}

		.model2 {
			width: auto;
		}

		.model3 {
			width: auto;
		}

		.a3 {
			font-size: 12px;
			padding: 0;
		}

		.xunhuan .xh:nth-of-type(1) {
			font-size: 12px;
		}
	}

	@media (max-width:1200px) {
		.container {
			width: auto;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/mine/g_xuankefangan_zyqkdcb.vue